import React, { Component } from "react";
import { connect } from "react-redux";
import { saveProfile } from "../actions/accountActions";
import { Redirect } from "react-router-dom";
import { withRouter } from "react-router";
import MyProfileForm from './MyProfileForm';
import OrdersList from './OrdersList';
import OrderDetails from '../components/OrderDetails';
import Wishlist from './Wishlist';
import { ProfileNavSectionsEnum } from "../common/enums";
import { withTranslation } from 'react-i18next';
import { utils} from "../common/utils";
import ExtendedLink  from "../components/ExtendedLink";
import Image from "../components/Image";
import NewWindow from "../components/NewWindow";
import ReferralDashboard from "../components/ReferralDashboard";

class MyProfile extends Component {
    state = { visibleWindow: false, selectedOrderId: 0 }

    updateProfileHandler(values) {
        const { user } = this.props;
        values.representative = user.representative;
        return this.props.saveProfile(values).then((response) => {
          //  console.log(response)
        }, (error) => {
            console.log(error)
        });
    }

    onSelectOrder(orderId) {
        this.setState({
            selectedOrderId: orderId,
            visibleWindow: true
        });
    }

    onCloseWindow = () => {
             // Clear Selected Order
        this.setState({
            visibleWindow: false,
            selectedOrderId: 0
        });
    }

    render() {
        const { t, user, settings, wishlist, selectedOrder } = this.props;
        if (user.isAuthenticated !== true) {
            return <Redirect to={settings.baseUrl} />;
        }
 
        const imageUrl = user.imageUrl ? user.imageUrl : settings.defaultImageUrl;

        const navSection = this.props.navSection ? this.props.navSection.toLowerCase() : ProfileNavSectionsEnum.Profile;
        let section = <MyProfileForm />;
        if (navSection === ProfileNavSectionsEnum.Orders)
            section = <OrdersList onSelectOrder={this.onSelectOrder.bind(this)} />;
        else if (navSection === ProfileNavSectionsEnum.Wishlist)
            section = <Wishlist />;
        else if (navSection === ProfileNavSectionsEnum.Referral)
            section = <ReferralDashboard></ReferralDashboard>;

        return (
            <div className="row">
                {/*{this.state.visibleWindow && <Window title={`${t("Order")}#${this.state.selectedOrderId}`} onClose={this.onCloseWindow} initialTop={position.top} initialLeft={position.left} initialHeight={dimenstions.height} initialWidth={dimenstions.width}>*/}
                {/*    <OrderDetails order={selectedOrder} />*/}
                {/*</Window>}*/}

                <NewWindow title={`${t("Order")}#${this.state.selectedOrderId}`} open={this.state.visibleWindow} onClose={this.onCloseWindow} >
                    <OrderDetails order={selectedOrder} settings={settings} />
                </NewWindow>
                    <div className="col-lg-4">
                        <aside className="user-info-wrapper">
                            <div className="user-cover" >
                            <div className="info-label" data-toggle="tooltip" title={`${t("You currently have")} ${user.activeTotalPoints} ${t("ENJO Points")}`}><i className="icon-medal"></i>{user.activeTotalPoints} {t("points")}</div>
                            </div>
                            <div className="user-info">
                            <div className="user-avatar">
                                <a className="edit-avatar" href={null} role="button" >{" "}</a>
                                {/*<img src={imageUrl} alt="User" />*/}
                                {imageUrl && <Image src={imageUrl} fallbackSrc="img/no-image.jpg" alt='' />}
                                </div>
                                <div className="user-data">
                                <h4>{`${user.firstName} ${user.lastName} `}</h4>
                                <span>{t("Joined")} {utils.dates.getDateString(user.createdAt)}</span>
                                </div>
                            </div>
                        </aside>
                        <nav className="list-group">
                            <ExtendedLink to={`${settings.baseUrl}account/profile`} className={`list-group-item with-badge ${navSection === ProfileNavSectionsEnum.Profile ? "active" : ""} `}>
                            <i className="icon-head"></i>{t("Profile")}
                            </ExtendedLink>
                            <ExtendedLink to={`${settings.baseUrl}account/orders`} className={`list-group-item with-badge ${navSection === ProfileNavSectionsEnum.Orders ? "active" : ""} `}>
                            <i className="icon-bag"></i>{t("Orders")}<span className="badge badge-primary badge-pill">{user.totalOrdersCount}</span>
                            </ExtendedLink>
                            <ExtendedLink to={`${settings.baseUrl}account/wishlist`} className={`list-group-item with-badge ${navSection === ProfileNavSectionsEnum.Wishlist ? "active" : ""} `}>
                            <i className="icon-bag"></i>{t("Wishlist")}<span className="badge badge-primary badge-pill">{wishlist ? wishlist.length : 0}</span>
                            </ExtendedLink>

                            <ExtendedLink to={`${settings.baseUrl}account/referral`} className={`list-group-item with-badge ${navSection === ProfileNavSectionsEnum.Referral ? "active" : ""} `}>
                            <i className="icon-bag"></i>{t("Referral Program")} 
                            {/* <span className="badge badge-primary badge-pill">{wishlist ? wishlist.length : 0}</span> */}
                            </ExtendedLink>
                            {/* 
                            <a className="list-group-item with-badge" href="account-wishlist.html"><i className="icon-heart"></i>Wishlist<span className="badge badge-primary badge-pill">3</span>
                            </a>
                            <a className="list-group-item with-badge" href="account-tickets.html"><i className="icon-tag"></i>My Tickets<span className="badge badge-primary badge-pill">4</span>
                            </a>*/}
                        </nav>
                    </div>
                    <div className="col-lg-8">
                        {section}
                    </div>
                </div>
        );
    }
}



function mapStateToProps({ user, settings, wishlist, selectedOrder }, ownProps) {
    var newState = { user, settings, wishlist, selectedOrder, ...ownProps };
    return newState;
} 


MyProfile = connect(mapStateToProps, { saveProfile: saveProfile })(withRouter(MyProfile))

export default withTranslation()(MyProfile);




